<template>
  <div class="bg-secondary">
    <div class="position-relative birthday-page bg-white shadow">
      <div class="sticky-header sticky-top" :class="`year-${year}`">
        <div class="dark-overlay">
          <div class="fixed-top text-left">
            <router-link :to="{ name: 'Home' }" class="btn btn-link text-white"
              >⬅️</router-link
            >
          </div>
          <div class="container">
            <h1 class="title" v-if="todaysActivity.title">
              {{ todaysActivity.title }}
            </h1>
            <p class="hint" v-if="todaysActivity.hint">
              {{ todaysActivity.hint }}
            </p>
          </div>
        </div>
      </div>
      <div class="list">
        <div
          v-for="(a, i) in activities"
          :key="i"
          v-on:click="selectDay(a.date)"
        >
          <list :value="a" :today="todayDate"></list>
        </div>
        <h3
          class="bday"
          v-if="todayDate != birthdate"
          v-on:click="selectDay(birthdate)"
        >
          <span>Birthday!</span>
        </h3>
      </div>
    </div>
    <div class="text-center"></div>
  </div>
</template>

<script>
import find from "lodash/find";
import moment from "moment";
import List from "@/components/List";

export default {
  name: "Home",
  components: {
    List
  },
  props: ["year"],
  data() {
    return {
      birthdate: `${this.year}-05-12`,
      todayDate: this.$route.query.date
        ? moment(this.$route.query.date).format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD"),
      todaysActivity: {
        title: "Hold on tight!",
        hint: "The birthday week is yet to begin.."
      },
      activities: []
    };
  },
  watch: {
    "$route.query.date"(to) {
      if (to) {
        location.reload();
      }
    }
  },
  created() {
    try {
      this.activities = require(`@/assets/json/activities/${this.year}`);
    } catch (error) {
      /* eslint-disable no-console */
      console.log(error);
    }
    if (moment(this.todayDate).isSame(this.birthdate, "day")) {
      this.todaysActivity = {
        title: "Happy Birthday!",
        hint: "I love you Jahn.."
      };
    } else {
      if (find(this.activities, { date: this.todayDate })) {
        this.todaysActivity = find(this.activities, { date: this.todayDate });
        this.todaysActivity.hint ? `Hint: ${this.todaysActivity.hint}` : "";
      }
    }
  },
  methods: {
    selectDay(date) {
      const query = { date: date };
      this.$router.push({ query: query });
    }
  }
};
</script>

<style scoped>
.birthday-page {
  min-height: 100vh;
  max-width: 600px;
  margin: 0 auto;
}
.sticky-header.year-2021 {
  background-image: url("../assets/images/2021.jpg");
}
.sticky-header.year-2020 {
  background-image: url("../assets/images/2020.jpg");
}
.sticky-header.year-2019 {
  background-image: url("../assets/images/2019.jpg");
}
.sticky-header {
  color: white;
  background-size: cover;
}
.dark-overlay {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.35);
  text-align: center;
  display: flex;
  align-items: center;
  height: 200px;
}
.title {
  font-family: "Lobster";
}
.hint {
  font-size: 1.2rem;
}
.list {
  padding: 15px 10px;
}

.bday {
  font-family: "Lobster";
  text-align: center;
  color: #ababab;
  position: relative;
  margin: 10px 0 5px;
}

.bday:before {
  content: "";
  height: 1px;
  background: #ababab;
  width: 100%;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}

.bday > span {
  background: white;
  z-index: 99999;
  position: relative;
  padding: 0 15px;
}
</style>
